import { useTheme } from '@/src/store/theme.context';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { Toggle } from '@amzn/awsui-components-react';
import { Mode } from '@amzn/awsui-global-styles';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faMoon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import styles from './ThemeToggle.module.scss';

export const ThemeToggle: React.FC = () => {
  const { t } = useTranslation();
  const { themeMode, setThemeMode } = useTheme();

  return (
    <Toggle
      checked={themeMode === Mode.Dark}
      onChange={({ detail }) => setThemeMode(detail.checked ? Mode.Dark : Mode.Light)}
      ariaLabel={t(i18nKeys.general.enableDarkMode)}
    >
      <FontAwesomeIcon icon={faMoon as IconProp} className={styles.icon} />
    </Toggle>
  );
};
